export const convertToISOString = (dateString: string): string => {
  if (dateString === '') {
    return '';
  }

  const delimiter = dateString.includes('-') ? '-' : '/';
  const parts = dateString.split(delimiter);
  const day = Number(parts[0]);
  const month = Number(parts[1]) - 1;
  const year = Number(parts[2]);

  const date = new Date(Date.UTC(year, month, day));

  return date.toISOString().split('T')[0] + 'T00:00:00.000Z';
};

export const formatDateDayMonthYear = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-');

  return `${day}-${month}-${year}`;
};
